import React from "react";
import { AppInput, AppSelect, AppButton } from "../scraper";
import { useState } from "react";

const AnalyticsFilters = ({
    filters,
    filterOptions = {},
    onChange,
    onReset,
}) => {
    const [showAdvanced, setShowAdvanced] = useState(false);
    const chips = [
        ["Search", "search"],
        ["Source", "utm_source"],
        ["Campaign", "utm_campaign"],
        ["Journey", "journey_stage"],
        ["From", "start_date"],
        ["To", "end_date"],
        ["Device", "device"],
        ["Converted", "converted"],
        ["User", "user_type"],
        ["Medium", "utm_medium"],
        ["Browser", "browser"],
        ["OS", "operating_system"],
        ["Language", "language"],
        ["Gateway", "gateway"],
    ];
    const activeCount = chips.filter(([, key]) => filters[key]).length;

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-slate-50 to-white">
            <div className="flex items-center justify-between px-4 py-3">
                <div>
                    <h2 className="text-sm font-semibold text-slate-900">Filters</h2>
                    <p className="text-xs text-slate-500">Narrow visitor journeys</p>
                </div>

                <button
                    onClick={() => setShowAdvanced(!showAdvanced)}
                    className="flex items-center gap-1 rounded-lg px-2.5 py-1.5 text-xs font-medium text-indigo-600 transition hover:bg-indigo-50"
                >
                    Advanced
                    <svg
                        className={`h-3.5 w-3.5 transition-transform duration-200 ${showAdvanced ? "rotate-180" : ""}`}
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                    >
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </button>
            </div>

            <div className="border-t border-slate-100 p-4">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                    <AppInput
                        label="Search"
                        placeholder="Email / Visitor UUID"
                        value={filters.search}
                        onChange={(e) => onChange("search", e.target.value)}
                    />
                    <AppSelect
                        label="Source"
                        value={filters.utm_source}
                        onChange={(e) => onChange("utm_source", e.target.value)}
                        placeholder="All Sources"
                        options={filterOptions.sources || []}
                    />
                    <AppSelect
                        label="Campaign"
                        value={filters.utm_campaign}
                        onChange={(e) => onChange("utm_campaign", e.target.value)}
                        placeholder="All Campaigns"
                        options={filterOptions.campaigns || []}
                    />
                    <AppSelect
                        label="Device"
                        value={filters.device}
                        onChange={(e) => onChange("device", e.target.value)}
                        placeholder="All Devices"
                        options={filterOptions.devices}
                    />
                    <AppSelect
                        label="Converted"
                        value={filters.converted}
                        onChange={(e) => onChange("converted", e.target.value)}
                        placeholder="All"
                        options={[
                            { label: "Converted", value: "1" },
                            { label: "Not Converted", value: "0" },
                        ]}
                    />
                    <AppInput
                        type="date"
                        label="From Date"
                        value={filters.start_date}
                        onChange={(e) => onChange("start_date", e.target.value)}
                    />

                    <AppInput
                        type="date"
                        label="To Date"
                        value={filters.end_date}
                        onChange={(e) => onChange("end_date", e.target.value)}
                    />
                    <AppSelect
                        label="Journey Stage"
                        value={filters.journey_stage}
                        onChange={(e) => onChange("journey_stage", e.target.value)}
                        placeholder="All Stages"
                        options={filterOptions.journey_stages || []}
                    />
                </div>

                {showAdvanced && (
                    <div className="mt-4 border-t border-slate-100 pt-4">
                        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                            Advanced Filters
                        </h3>
                        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <AppSelect
                                label="Medium"
                                value={filters.utm_medium}
                                onChange={(e) => onChange("utm_medium", e.target.value)}
                                options={filterOptions.mediums || []}
                                placeholder="All Mediums"
                            />
                            <AppSelect
                                label="Browser"
                                value={filters.browser}
                                onChange={(e) => onChange("browser", e.target.value)}
                                options={filterOptions.browsers || []}
                                placeholder="All Browsers"
                            />
                            <AppSelect
                                label="Operating System"
                                value={filters.operating_system}
                                onChange={(e) => onChange("operating_system", e.target.value)}
                                options={filterOptions.operating_systems || []}
                                placeholder="All Operating Systems"
                            />
                            <AppSelect
                                label="Language"
                                value={filters.language}
                                onChange={(e) => onChange("language", e.target.value)}
                                options={filterOptions.languages || []}
                                placeholder="All Languages"
                            />
                            <AppSelect
                                label="Gateway"
                                value={filters.gateway}
                                onChange={(e) => onChange("gateway", e.target.value)}
                                options={[
                                    { label: "Razorpay", value: "razorpay" },
                                    { label: "PayPal", value: "paypal" },
                                    { label: "Stripe", value: "stripe" },
                                ]}
                                placeholder="All Gateways"
                            />
                            <AppInput
                                label="Landing Page"
                                value={filters.landing_path}
                                onChange={(e) => onChange("landing_path", e.target.value)}
                            />
                            <AppInput
                                label="Referrer"
                                value={filters.referrer}
                                onChange={(e) => onChange("referrer", e.target.value)}
                            />
                            <AppSelect
                                label="User Type"
                                value={filters.user_type}
                                onChange={(e) => onChange("user_type", e.target.value)}
                                placeholder="All Users"
                                options={[
                                    { label: "Guest", value: "guest" },
                                    ...(filterOptions.user_types || []).map(item => ({
                                        label: item.value === "user" ? "Artist" : item.label,
                                        value: item.value,
                                    })),
                                ]}
                            />
                        </div>
                    </div>
                )}

                {activeCount > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1.5">
                        {chips.map(([label, key]) => {
                            if (!filters[key]) return null;
                            return (
                                <Chip
                                    key={key}
                                    label={`${label}: ${filters[key]}`}
                                    onRemove={() => onChange(key, "")}
                                />
                            );
                        })}
                    </div>
                )}

                <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-3">
                    <span className="text-xs font-medium text-slate-500">
                        {activeCount} active filter{activeCount !== 1 ? "s" : ""}
                    </span>
                    <AppButton variant="ghost" onClick={onReset}>
                        Reset Filters
                    </AppButton>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsFilters;

const Chip = ({ label, onRemove }) => (
    <div className="flex items-center gap-1.5 rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-medium text-indigo-700">
        {label}
        <button onClick={onRemove} className="text-indigo-400 hover:text-indigo-700">
            ✕
        </button>
    </div>
);